import { LocationModel } from "src/app/models/container_master_model/location";


export interface IRequestAlterModel {
    pols: string[];
    pods: string[];
    delete_missing_locations?: boolean;
}

export interface RequestAlterError {
    pols: string[];
    pods: string[];
}

export class RequestAlterModel {
    pols: LocationModel[];
    pods: LocationModel[];
    delete_missing_locations: boolean;

    error: RequestAlterError;

    constructor() {
        this.pols = [];
        this.pods = [];

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            pols: [],
            pods: [],
        }
    }

    setPayload(data) {
        this.pols = [...data.pols];
        this.pods = [...data.pods];
    }

    getRequestData(): IRequestAlterModel {
        return {
            pols: this.pols.map((item) => item.id),
            pods: this.pods.map((item) => item.id),
        }
    }
}